<upsc-element-blocker *ngIf="isInProgress"></upsc-element-blocker>
<div id="costEstimator"
     class="ups-dialog cost-estimator"
     role="dialog"
     aria-labelledby="Cost Estimator"
     aria-hidden="true">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{ 'costEstimator.Title'|translate }}</h2>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <mat-dialog-content>
        <ng-container [ngTemplateOutlet]="form"></ng-container>
        <ng-container [ngTemplateOutlet]="services"></ng-container>
    </mat-dialog-content>
</div>

<ng-template #form>
    <form #estimateForm
          [formGroup]="formGroup"
          *ngIf="estimator"
          class="ups-form"
          (ngSubmit)="onSubmit($event, formGroup.value)">
        <div class="form-body">
            <div class="form-sections">
                <div class="info">
                    <div class="form-section ship-info">
                        <div class="form-section-header">
                            <h5 class="form-section-title">{{ 'costEstimator.ShippingInformation'|translate }}</h5>
                        </div>
                        <mat-form-field>
                            <mat-label>{{ 'costEstimator.SelectShipFromAddress'|translate }}</mat-label>
                            <mat-select formControlName="ShipFromAddress"
                                        (selectionChange)="populateShipFrom($event.value)">
                                <mat-option value="0">{{ 'costEstimator.SelectShipFromAddress'|translate }}</mat-option>
                                <mat-option *ngFor="let location of shipFromLocations"
                                            value="{{location.ContactId}}"> {{ location.StreetAddress }},
                                    {{ location.City }}, {{ location.State }}, {{ location.Zip }},
                                    {{ location.Country }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>{{ 'costEstimator.SelectShipToCountry'|translate }}</mat-label>
                            <mat-select formControlName="ShipToCountry"
                                        required
                                        (selectionChange)="onToCountryChange($event.value)">
                                <mat-option value="0">{{ 'costEstimator.SelectShipToCountry'|translate }}</mat-option>
                                <mat-option *ngFor="let country of countriesList"
                                            value="{{country.CountryCode}}"> {{ country.CountryName }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>{{ 'costEstimator.ShipToPostalCode'|translate }}</mat-label>
                            <!--[MV3-1550]: Disable postal code textbox if it is not required for the country selected-->
                            <input formControlName="PostalCode"
                                   [required]="isZipMandatory==true ? true : null"
                                   matInput
                                   onfocus="this.select();"
                                   type="text"
                                   [disabled]="!isZipMandatory"
                                   autocomplete="off">
                            <mat-error *ngIf="isZipMandatory==true && formGroup.controls.PostalCode.errors?.required">
                            <span *ngIf="isZipMandatory==true && formGroup.controls.PostalCode.errors?.required">
                           {{ 'costEstimator.PostalCodeRequired'|translate }}
                        </span>
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>{{'InsuredValue'|translate}}</mat-label>
                            <input formControlName="InsuredValue"
                                   required
                                   matInput
                                   min="0"
                                   max="{{ maxInsuredValue }}"
                                   pattern="[0-9]+"
                                   onfocus="this.select();"
                                   type="text"
                                   autocomplete="off">
                            <span matSuffix>{{ currencyCode }}</span>
                            <mat-error *ngIf="formGroup.controls.InsuredValue?.errors">
                                <span *ngIf="formGroup.controls.InsuredValue?.errors?.required">{{ 'InsuredValueRequired'|translate }}</span>
                                <span *ngIf="formGroup.controls.InsuredValue?.errors?.min">{{ 'InsuredValueNegativeNotAllowed'|translate }}</span>
                                <span *ngIf="formGroup.controls.InsuredValue?.errors?.max">{{ 'InsuredValueCannotExceed'|translate }} {{ maxInsuredValue }}
                                    .</span>
                                <span *ngIf="formGroup.controls.InsuredValue?.errors?.notInteger">{{ 'InsuredValueNotInteger'|translate }}</span>
                            </mat-error>
                        </mat-form-field>
                        <mat-form-field>
                            <mat-label>{{'Weight'|translate}}</mat-label>
                            <input formControlName="Weight"
                                   required
                                   matInput
                                   min="0.01"
                                   max="{{ maxWeight }}"
                                   onfocus="this.select();"
                                   type="text"
                                   autocomplete="off">
                            <span matSuffix>{{ weightUOM }}</span>
                            <mat-error *ngIf="formGroup.controls.Weight.errors">
                                <span *ngIf="formGroup.controls.Weight.errors?.required">{{ 'WeightRequired'|translate }}</span>
                                <span *ngIf="formGroup.controls.Weight?.errors?.max">{{ 'WeightCannotExceed'|translate }}
                                    <strong>{{ maxWeight }}.</strong></span>
                            </mat-error>
                        </mat-form-field>
                        <mat-checkbox
                                *ngIf="formGroup.controls.ShipToCountry.value =='CA' || formGroup.controls.ShipToCountry.value =='US'"
                                formControlName="ShipToResidential">{{ 'costEstimator.ResidentialAddress'|translate }}
                        </mat-checkbox>
                    </div>
                </div>
                <div class="options">
                    <div class="form-section ship-options">
                        <div class="form-section-header"
                             *ngIf="formGroup.controls.ShipToCountry.value =='CA' || formGroup.controls.ShipToCountry.value =='US'">
                            <h5 class="form-section-title">{{ 'ShippingOptions'|translate }}</h5>
                        </div>

                        <mat-checkbox
                                *ngIf="formGroup.controls.ShipToCountry.value =='CA' || formGroup.controls.ShipToCountry.value =='US'"
                                formControlName="IsSaturdayPickUp">{{ 'SaturdayPickup'|translate }}
                        </mat-checkbox>
                        <mat-checkbox
                                *ngIf="formGroup.controls.ShipToCountry.value =='CA' || formGroup.controls.ShipToCountry.value =='US'"
                                formControlName="IsSaturdayDelivery">{{ 'SaturdayDelivery'|translate }}
                        </mat-checkbox>
                        <!-- <div *ngIf="formGroup.controls.ShipToCountry.value =='CA' || formGroup.controls.ShipToCountry.value =='US'">
                            <mat-checkbox formControlName="IsCOD" (click)="setCOD()">{{'CODServices'|translate}}
                            </mat-checkbox>
                            <div class="cod" *ngIf="formGroup.controls.IsCOD.value">
                                <input type="text"
                                       formControlName="CodAmount"
                                       required
                                       matInput    
                                       onfocus="this.select();"                                   
                                       placeholder="{{'CODAmount'|translate}}"
                                       autocomplete="off">
                                <br>
                                <mat-checkbox formControlName="IsSecuredCOD">
                                    {{'SecuredCODOnly'|translate}}
                                </mat-checkbox>
                            </div>
                        </div> -->
                        <mat-checkbox
                                *ngIf="formGroup.controls.ShipToCountry.value =='CA' || formGroup.controls.ShipToCountry.value =='US'"
                                formControlName="IsCustomPackaging"
                                (click)="customPackaging()">{{ 'costEstimator.CustomPackaging'|translate }}
                        </mat-checkbox>
                        <div class="custom-packaging" *ngIf="formGroup.controls.IsCustomPackaging.value">
                            <mat-form-field>
                                <input formControlName="Length"
                                       placeholder="{{'Length'|translate}}"
                                       [required]="formGroup.controls.IsCustomPackaging.value"
                                       matInput
                                       onfocus="this.select();"
                                       type="text"
                                       autocomplete="off"
                                       (input)="calculateWeight()">
                                <mat-error
                                        *ngIf="formGroup.controls.IsCustomPackaging.value && formGroup.controls.Length.errors?.required">
                            <span *ngIf="formGroup.controls.IsCustomPackaging.value && formGroup.controls.Length.errors?.required">
                                {{ 'PackageLengthRequired'|translate }}
                            </span>
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field>
                                <input formControlName="Width"
                                       placeholder="{{'Width'|translate}}"
                                       matInput
                                       onfocus="this.select();"
                                       type="text"
                                       autocomplete="off"
                                       (input)="calculateWeight()"
                                       [required]="formGroup.controls.IsCustomPackaging.value">
                                <mat-error
                                        *ngIf="formGroup.controls.IsCustomPackaging.value && formGroup.controls.Width.errors?.required">
                            <span *ngIf="formGroup.controls.IsCustomPackaging.value && formGroup.controls.Width.errors?.required">
                                {{ 'PackageWidthRequired'|translate }}
                            </span>
                                </mat-error>
                            </mat-form-field>
                            <mat-form-field>
                                <input formControlName="Height"
                                       placeholder="{{'Height'|translate}}"
                                       matInput
                                       onfocus="this.select();"
                                       type="text"
                                       autocomplete="off"
                                       (input)="calculateWeight()"
                                       [required]="formGroup.controls.IsCustomPackaging.value">
                                <mat-error
                                        *ngIf="formGroup.controls.IsCustomPackaging.value && formGroup.controls.Height.errors?.required">
                            <span *ngIf="formGroup.controls.IsCustomPackaging.value && formGroup.controls.Height.errors?.required">
                                {{ 'PackageHeightRequired'|translate }}
                            </span>
                                </mat-error>
                            </mat-form-field>
                            <span>{{ dimensionUnit }}</span>
                        </div>
                        <div class="custom-packaging-note" *ngIf="isCustomPackaging">
                            <p>{{ 'costEstimator.PackagesGreaterThan18X18X7'|translate }}
                                <a href="https://www.ups.com/us/en/help-center/packaging-and-supplies/determine-billable-weight.page"
                                   target="_blank"> {{ 'DimensionalWeight'|translate }}</a>.
                            </p>
                        </div>
                    </div>
                    <div class="form-section pickup-options">
                        <div class="form-section-header">
                            <h5 class="form-section-title">{{ 'costEstimator.PickupOptions'|translate }}</h5>
                        </div>

                        <mat-radio-group class="pickup" formControlName="PickupOption">
                            <mat-radio-button value="1">{{ 'costEstimator.SchedulePickup'|translate }}
                            </mat-radio-button>
                            <mat-radio-button value="2">{{ 'costEstimator.ShippingDropOff'|translate }}
                            </mat-radio-button>
                            <mat-radio-button value="3">{{ 'costEstimator.MyPickupLocation'|translate }}
                            </mat-radio-button>
                        </mat-radio-group>
                    </div>
                </div>
            </div>

            <ng-container [ngTemplateOutlet]="disclaimer"></ng-container>
        </div>
        <div class="form-footer">
            <div class="form-actions" *ngIf="estimator">
                <button type="button" mat-raised-button (click)="reset()" class="alternative-button">
                    {{ 'Reset'|translate }}
                </button>
                <button type="submit" mat-raised-button [disabled]="!formGroup.valid" color="primary">
                    {{ 'costEstimator.GetQuotes'|translate }}
                </button>
            </div>
        </div>
    </form>
</ng-template>

<ng-template #services>
    <div *ngIf="serviceList" class="services">
        <mat-radio-group [(ngModel)]="selectedEstimateId" (change)="onEstimateRadioChanged(selectedEstimateId)">
            <mat-expansion-panel class="shipping-options ups"
                                 #upsServicesPanel
                                 [expanded]="true"
                                 (opened)="onUpsServicesOpened()"
                                 (closed)="onUpsServicesClosed()">
                <mat-expansion-panel-header
                        [class.blur]="!isUpsServiceSelected && isFedExServiceSelected && isUpsServicesClosed && isMobile">
                    <mat-panel-title>
                        <div class="shipping-options-header"
                             *ngIf="(!isUpsServiceSelected && isUpsServicesClosed) || !isUpsServicesClosed || !isMobile">
                            <img class="carrier-icon" src="../../assets/icons/icon-ups.png" alt="UPS">
                            <h1 class="shipping-options-title">{{ 'ShippingOptions'|translate }}</h1>
                        </div>
                        <div class="shipping-options-header"
                             *ngIf="isUpsServiceSelected && isUpsServicesClosed && isMobile">
                            <img class="carrier-icon summary" src="../../assets/icons/icon-ups.png" alt="UPS">
                            <ng-container [ngTemplateOutlet]="selectedService"></ng-container>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <ul class="services">
                    <li class="service" *ngFor="let service of upsServices">
                        <label>
                            <mat-radio-button value="{{ service.EstimatorHeaderID }}"></mat-radio-button>
                            <upsc-ship-service-estimate [estimator]="service"
                                                        [insuredValue]="formGroup.controls.InsuredValue.value"
                                                        [customerServices]="customerServices"
                                                        (estimateChanged)="onEstimateChanged($event)"></upsc-ship-service-estimate>
                        </label>
                    </li>
                </ul>
            </mat-expansion-panel>

            <mat-expansion-panel class="shipping-options fedex"
                                 #fedexServicesPanel
                                 [expanded]="true"
                                 (opened)="onFedExServicesOpened()"
                                 (closed)="onFedExServicesClosed()">
                <mat-expansion-panel-header
                        [class.blur]="isUpsServiceSelected && !isFedExServiceSelected && isFedExServicesClosed && isMobile">
                    <mat-panel-title>
                        <div class="shipping-options-header"
                             *ngIf="(!isFedExServiceSelected && isFedExServicesClosed) || !isFedExServicesClosed || !isMobile">
                            <img class="carrier-icon" src="../../assets/icons/icon-fedex.png" alt="FedEx">
                            <h1 class="shipping-options-title">{{ 'ShippingOptions'|translate }}</h1>
                        </div>
                        <div class="shipping-options-header"
                             *ngIf="isFedExServiceSelected && isFedExServicesClosed && isMobile">
                            <img class="carrier-icon summary" src="../../assets/icons/icon-fedex.png" alt="FedEx">
                            <ng-container [ngTemplateOutlet]="selectedService"></ng-container>
                        </div>
                    </mat-panel-title>
                </mat-expansion-panel-header>

                <ul class="services">
                    <li class="service" *ngFor="let service of fedexServices">
                        <label>
                            <mat-radio-button value="{{ service.EstimatorHeaderID }}"></mat-radio-button>
                            <upsc-ship-service-estimate [estimator]="service"
                                                        [insuredValue]="formGroup.controls.InsuredValue.value"
                                                        [customerServices]="customerServices"
                                                        (estimateChanged)="onEstimateChanged($event)"></upsc-ship-service-estimate>
                        </label>
                    </li>
                </ul>
            </mat-expansion-panel>
        </mat-radio-group>

        <ng-container [ngTemplateOutlet]="disclaimer"></ng-container>

        <button mat-raised-button type="button" (click)="shipNow($event)" class="ship-now">
            {{ 'costEstimator.ShipNow'|translate }}
        </button>
    </div>
</ng-template>

<ng-template #disclaimer>
    <p class="disclaimer">
        <strong>{{ 'costEstimator.Disclaimer'|translate }}</strong>
        {{ 'costEstimator.Disclaimer_msg'|translate }}
    </p>
</ng-template>

<ng-template #selectedService>
    <div class="ship-service-estimate">
        <div class="details">
            <div class="title">
                <h4 class="service-name">{{ selectedEstimator?.ServiceCodeDescription }}</h4>
                <div class="transit-days">{{ 'costEstimator.transitDays'|translate : { TransitDays: estimator?.BusinessDaysInTransit } }}</div>
            </div>
            <div class="costs">
                <span class="base-fee">{{ 'costEstimator.fees.baseFee'|translate }}
                    ({{ selectedEstimator?.BaseRate | currency: 'USD' : 'symbol' }}) +</span>
                <span class="accessorial-cost">{{ 'costEstimator.fees.accessorialCost'|translate }}
                    ({{ selectedEstimator?.AccessorialsCost | currency: 'USD' : 'symbol' }})</span>
                <span class="accessorial-fee">{{ 'costEstimator.fees.fuelCharge'|translate }}
                    ({{ selectedEstimator?.EstimatorDetail[0].AccessorialFee | currency: 'USD' : 'symbol' }})</span>
                <span class="shipping-cost">{{ 'costEstimator.fees.shippingCost'|translate }}
                    ({{ selectedEstimator?.ShippingCost ? estimator.ShippingCost : 0 | currency: 'USD' : 'symbol' }}
                    )</span>
            </div>
        </div>
        <div class="summary">
            <div class="total">
                <!--{{ selectedEstimator?.TotalCharges | currency: 'USD' : 'symbol' }}    -->
                {{ selectedEstimator?.TotalCharges == 0 ? 'N/A' : selectedEstimator?.TotalCharges | currency: 'USD' : 'symbol' }}
            </div>
        </div>
    </div>
</ng-template>
